import { CSkeleton } from "./CSkeleton"

export const CSkeletonDashboard = () => {

    return (
        <div className=" w-full flex flex-col">

            <div className="w-full  mt-[30px] flex flex-col">
                <div className=" w-[150px] rounded-lg h-[30px] flex items-center overflow-hidden">
                    <CSkeleton />
                </div>
                <div className="w-full flex flex-wrap mt-[10px]">
                    <div className=" w-[50%] md:w-[24%] pl-1 md:pl-2 order-1 ">
                        <div className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow flex flex-col justify-between items-center overflow-hidden">
                            <CSkeleton />
                        </div>
                    </div>
                    <div className="w-full md:w-[38%] px-0 md:px-1 order-3 md:order-2  md:mt-0 mt-2">
                        <div className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow flex justify-center items-center overflow-hidden">
                            <CSkeleton />
                        </div>
                    </div>
                    <div className="w-[50%] md:w-[38%] pr-1 md:pr-2 order-2 md:order-3 ">
                        <div className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow flex justify-center items-center overflow-hidden">
                            <CSkeleton />
                        </div>
                    </div>
                </div>
            </div>

            <div className=" w-full flex items-center flex-wrap">
                <div className=" w-full md:w-6/12 pl-0 md:pl-2">
                    <div className="w-full  mt-[30px] flex flex-col">
                        <div className=" w-[150px] rounded-lg h-[30px] flex items-center overflow-hidden">
                            <CSkeleton />
                        </div>
                        <div className="w-full flex flex-wrap mt-[10px]">
                            <div className=" w-[50%]  pl-[5px]  ">
                                <div className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow  flex flex-col justify-between items-center overflow-hidden">
                                    <CSkeleton />
                                </div>
                            </div>
                            <div className=" w-[50%]  pr-[5px]  ">
                                <div className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow  flex flex-col justify-between items-center overflow-hidden">
                                    <CSkeleton />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" w-full md:w-6/12 pl-0 md:pl-2">
                    <div className="w-full  mt-[30px] flex flex-col">
                        <div className="w-[150px] rounded-lg h-[30px] flex items-center overflow-hidden">
                            <CSkeleton/>
                        </div>
                        <div className="w-full flex flex-wrap mt-[10px]">
                            <div className=" w-[50%]  pl-[5px]  ">
                                <div className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow  flex flex-col justify-between items-center overflow-hidden">
                                    <CSkeleton/>
                                </div>
                            </div>
                            <div className=" w-[50%]  pr-[5px]  ">
                                <div className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow  flex flex-col justify-between items-center overflow-hidden">
                                    <CSkeleton/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className=" w-full flex items-center flex-wrap">
                <div className=" w-full md:w-6/12 pl-0 md:pl-2">
                    <div className="w-full  mt-[30px] flex flex-col">
                        <div className=" w-[150px] h-[30px] rounded-lg flex items-center overflow-hidden">
                            <CSkeleton/>
                        </div>
                        <div className="w-full flex flex-wrap mt-[10px]">
                            <div className=" w-[50%]  pl-[5px]  ">
                                <div className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow  flex flex-col justify-between items-center overflow-hidden">
                                    <CSkeleton/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
